import { Col, Row } from 'reactstrap';
import AdminPage from '../../components/admin/AdminPage';
import { useParams } from 'react-router-dom';
import ProjectShowroomInfoCard from './components/ProjectShowroomInfoCard';

const InvestorProjectShowroomConfig = () => {
  const { id = '' } = useParams();

  return (
    <AdminPage name="Configurar Showroom" parentName="Proyectos">
      <Row>
        <Col md="8">
          <ProjectShowroomInfoCard projectId={id} />
        </Col>
      </Row>
    </AdminPage>
  );
};

export default InvestorProjectShowroomConfig;
